module.exports = __webpack_public_path__ + "img/sixpackcarrier68.9909c3c8.jpg";